"use client";
import DefaultShop from "@/templates/default/pages/Shop";
import { ShopPageProps } from "@/templates/types";
import { StorePagesLoader } from "../page-template-loaders/store-pages-loader";

const ShopPage: React.FC<ShopPageProps> = (props) => {
  return (
    <StorePagesLoader>
      <DefaultShop {...props} />
    </StorePagesLoader>
  );
};

export default ShopPage;
